exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-line-chart[data-v-46c41720]{position:relative;width:100%;height:100%}", ""]);

// exports
